import { motion } from 'framer-motion';

const SectionHeading = ({ 
  badge, 
  title, 
  description, 
  align = 'center',
  className = '' 
}) => {
  const alignmentClasses = {
    center: 'text-center',
    left: 'text-left',
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className={`max-w-3xl ${align === 'center' ? 'mx-auto' : ''} mb-12 ${alignmentClasses[align]} ${className}`}
    >
      {badge && (
        <span className="inline-block px-4 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
          {badge}
        </span>
      )}
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground font-['Outfit'] tracking-tight mb-4">
        {title}
      </h2>
      {description && (
        <p className="text-muted-foreground text-base md:text-lg leading-relaxed">
          {description}
        </p>
      )}
    </motion.div>
  );
};

export default SectionHeading;
